module.exports = __webpack_public_path__ + "img/pronet-logo.f598e93d.svg";